import React, { createContext } from 'react';
import { RemoteParticipant } from 'twilio-video';
import useRemoteParticipant from '../hooks/useRemoteParticipant';

/**
 * The purpose of the ParticipantProvider component is to ensure that the hooks useGalleryViewParticipants
 * and useSpeakerViewParticipants are not unmounted as users switch between Gallery View and Speaker View.
 * This will make sure that the ordering of the participants on the screen will remain so that the most
 * recent dominant speakers are always at the front of the list.
 */

export interface IParticipantContext {
  remoteParticipant: RemoteParticipant | undefined;
}

export const ParticipantContext = createContext<IParticipantContext>(null!);

export const ParticipantProvider: React.FC = ({ children }) => {
  const remoteParticipant = useRemoteParticipant();

  return (
    <ParticipantContext.Provider
      value={{
        remoteParticipant,
      }}
    >
      {children}
    </ParticipantContext.Provider>
  );
};
